<template>
  <header>
    <div class="header appbar_tab1">
      <!-- 返回按钮 -->
      <div class="block_content" v-if="back">
        <a href="javascript:history.back()" class="subpage_backurl"><img alt="" src="/static/image/arrow_left.png" /></a>
      </div>
      <!-- 无返回 -->
      <div class="title menu_notification" v-if="!back">
        <a href="" style="visibility: hidden"><img class="svg" alt="" src="/static/image/notification.png" /></a>
      </div>
      <!-- 标题 -->
      <div class="block_content" v-if="title">
        <div class="title page_header_title">{{ title }}</div>
      </div>
      <!-- 无标题 -->
      <div class="block_content" v-if="!title">
        <div class="title">
          <img alt="" :src="$store.state.appInfo.site_logo || '/static/image/logo_appbar.png'" onerror="this.src = '/static/image/logo_appbar.png'" class="logo" />
        </div>
      </div>
      <div class="block_content">
        <div class="title cs_or_wallet" @click="$parent.openKefu">
          <a class="cs_selector_btn"><img alt="" src="/static/image/cs.png" /></a>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: 'Header',
  data() {
    return { title: '', back: false };
  },
  created() {
    let that = this;
  },
  methods: {
    changPath() {
      let that = this;
      let path = this.$route.path;
      if (path == '/') {
        that.back = false;
        that.title = '';
      }
      if (path == '/discount') {
        that.back = false;
        that.title = '优惠';
      }
      if (path == '/wallet') {
        that.back = false;
        that.title = '钱包';
      }
      if (path == '/withdraw') {
        that.back = false;
        that.title = '钱包';
      }
      if (path == '/transfer') {
        that.back = false;
        that.title = '钱包';
      }
      if (path == '/mine') {
        that.back = false;
        that.title = '我的';
      }
      if (path == '/electronics') {
        that.back = true;
        that.title = '游戏列表';
      }
      if (path == '/discountInfo') {
        that.back = true;
        that.title = '优惠详情';
      }
      if (path == '/customer') {
        that.back = true;
        that.title = '客户服务';
      }
      if (path == '/apply') {
        that.back = true;
        that.title = '代理申请';
      }
      if (path == '/setting') {
        that.back = true;
        that.title = '设置';
      }
      if (path == '/about') {
        that.back = true;
        that.title = '关于我们';
      }
      if (path == '/applyList') {
        that.back = true;
        that.title = '活动申请记录';
      }
      if (path == '/account') {
        that.back = true;
        that.title = '账号安全中心';
      }
      if (path == '/vip') {
        that.back = true;
        that.title = 'VIP权益';
      }
      if (path == '/bankCard') {
        that.back = true;
        that.title = '取款绑定管理';
      }
      if (path == '/addBankCard') {
        that.back = true;
        that.title = '绑定银行卡';
      }
      if (path == '/addUsdtAds') {
        that.back = true;
        that.title = '绑定电子钱包';
      }
      if (path == '/meyList') {
        that.back = true;
        that.title = '钱包记录';
      }
      if (path == '/welfare') {
        that.back = true;
        that.title = '福利中心';
      }
      if (path == '/hongbao') {
        that.back = true;
        that.title = '抢红包';
      }
      if (path == '/kefu') {
        that.back = false;
        that.title = '客服';
      }
    },
  },
  mounted() {},
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.changPath();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/chunk-b7675268.a1b3941c.css';
</style>



// WEBPACK FOOTER //
// src/components/libs/Header.vue